module.exports = (__webpack_require__(71571))(6540);